
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { IconName } from "@/lib/icons/icons";
import RawIcon from "@/components/UI/RawIcon.vue";
import { IconRotation } from "@/types/icons";

@Component({
  components: { RawIcon }
})
export default class Icon extends Vue {
  @Prop({ default: 14 })
  size!: number;

  @Prop()
  rotate?: IconRotation;

  @Prop()
  icon!: IconName;

  @Prop()
  heightAuto?: boolean;

  get hasClickEvent() {
    return this.$listeners?.click;
  }
}
